// extracted by mini-css-extract-plugin
module.exports = {"productName":"RecipeCard_productName__qunq5","topSectionContainer":"RecipeCard_topSectionContainer__SWo4d","tags":"RecipeCard_tags__wxa1E"};